// Copyright (c) 2020 WiseTime. All rights reserved.

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file legebill/type/tag.proto (package legebill.type, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file legebill/type/tag.proto.
 */
export const file_legebill_type_tag: GenFile = /*@__PURE__*/
  fileDesc("ChdsZWdlYmlsbC90eXBlL3RhZy5wcm90bxINbGVnZWJpbGwudHlwZSLABQoDVGFnEgoKAmlkGAEgASgJEg8KB3NpdGVfaWQYAiABKAkSFwoPdGFnX2NhdGVnb3J5X2lkGAwgASgJEgwKBG5hbWUYBCABKAkSEwoLZGVzY3JpcHRpb24YBSABKAkSKwoIa2V5d29yZHMYBiADKAsyGS5sZWdlYmlsbC50eXBlLlRhZ0tleXdvcmQSEwoLZXh0ZXJuYWxfaWQYByABKAkSFAoMZXh0ZXJuYWxfdXJsGAggASgJEikKBnNvdXJjZRgJIAEoDjIZLmxlZ2ViaWxsLnR5cGUuVGFnLlNvdXJjZRIpCgZzdGF0dXMYCiABKA4yGS5sZWdlYmlsbC50eXBlLlRhZy5TdGF0dXMSPgoRc3VnZ2VzdGlvbl9jb25maWcYCyABKA4yIy5sZWdlYmlsbC50eXBlLlRhZy5TdWdnZXN0aW9uQ29uZmlnEh0KFWFzc2lnbmVlX2V4dGVybmFsX2lkcxgOIAMoCRJRCh5kZWZhdWx0X3RpbWVzaGVldF9maWVsZF92YWx1ZXMYDyADKAsyKS5sZWdlYmlsbC50eXBlLkRlZmF1bHRUaW1lc2hlZXRGaWVsZFZhbHVlIjkKBlNvdXJjZRIWChJTT1VSQ0VfVU5TUEVDSUZJRUQQABIICgRVU0VSEAESDQoJQ09OTkVDVE9SEAIiUwoQU3VnZ2VzdGlvbkNvbmZpZxIhCh1TVUdHRVNUSU9OX0NPTkZJR19VTlNQRUNJRklFRBAAEgwKCEVMSUdJQkxFEAESDgoKRElTQUxMT1dFRBACIjsKBlN0YXR1cxIWChJTVEFUVVNfVU5TUEVDSUZJRUQQABILCgdFTkFCTEVEEAESDAoIQVJDSElWRUQQAkoECAMQBEoECA0QDlINYWJzb2x1dGVfcGF0aFIYZGVmYXVsdF9hY3Rpdml0eV90eXBlX2lkIlsKGkRlZmF1bHRUaW1lc2hlZXRGaWVsZFZhbHVlEhoKEnRpbWVzaGVldF9maWVsZF9pZBgBIAEoCRIhChl0aW1lc2hlZXRfZmllbGRfb3B0aW9uX2lkGAIgASgJImIKClRhZ1NoYWxsb3cSCgoCaWQYASABKAkSDwoHc2l0ZV9pZBgCIAEoCRIMCgRuYW1lGAMgASgJEhMKC2Rlc2NyaXB0aW9uGAQgASgJEhQKDGV4dGVybmFsX3VybBgFIAEoCSIqCgpUYWdLZXl3b3JkEg4KBnRhZ19pZBgBIAEoCRIMCgR0ZXh0GAIgASgJQiMKFWNvbS5sZWdlYmlsbC5hcGkudHlwZUIIVGFnUHJvdG9QAWIGcHJvdG8z");

/**
 * Resource sites/*\/tags/*
 *
 * @generated from message legebill.type.Tag
 */
export type Tag = Message<"legebill.type.Tag"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * The Legebill site this tag belongs to.
   * Equivalent to a team ID.
   *
   * @generated from field: string site_id = 2;
   */
  siteId: string;

  /**
   * Optional. Set if this tag belongs to a tag category.
   *
   * @generated from field: string tag_category_id = 12;
   */
  tagCategoryId: string;

  /**
   * E.g. WT-1234
   *
   * @generated from field: string name = 4;
   */
  name: string;

  /**
   * Displayed to the user and used when searching for tags.
   *
   * @generated from field: string description = 5;
   */
  description: string;

  /**
   * Used for auto tagging and search.
   *
   * @generated from field: repeated legebill.type.TagKeyword keywords = 6;
   */
  keywords: TagKeyword[];

  /**
   * The tag's external identifier in the connected system.
   * The ID of the entity that the tag relates to in the connected system.
   *
   * @generated from field: string external_id = 7;
   */
  externalId: string;

  /**
   * If set, WiseTime can link to the external URL when the user clicks on the tag.
   * E.g. https://jira.wisetime.com/issues/WT-1234
   *
   * @generated from field: string external_url = 8;
   */
  externalUrl: string;

  /**
   * @generated from field: legebill.type.Tag.Source source = 9;
   */
  source: Tag_Source;

  /**
   * @generated from field: legebill.type.Tag.Status status = 10;
   */
  status: Tag_Status;

  /**
   * @generated from field: legebill.type.Tag.SuggestionConfig suggestion_config = 11;
   */
  suggestionConfig: Tag_SuggestionConfig;

  /**
   * @generated from field: repeated string assignee_external_ids = 14;
   */
  assigneeExternalIds: string[];

  /**
   * @generated from field: repeated legebill.type.DefaultTimesheetFieldValue default_timesheet_field_values = 15;
   */
  defaultTimesheetFieldValues: DefaultTimesheetFieldValue[];
};

/**
 * Describes the message legebill.type.Tag.
 * Use `create(TagSchema)` to create a new message.
 */
export const TagSchema: GenMessage<Tag> = /*@__PURE__*/
  messageDesc(file_legebill_type_tag, 0);

/**
 * @generated from enum legebill.type.Tag.Source
 */
export enum Tag_Source {
  /**
   * @generated from enum value: SOURCE_UNSPECIFIED = 0;
   */
  SOURCE_UNSPECIFIED = 0,

  /**
   * Created by a user at their Legebill site.
   *
   * @generated from enum value: USER = 1;
   */
  USER = 1,

  /**
   * Created by a site's connector.
   *
   * @generated from enum value: CONNECTOR = 2;
   */
  CONNECTOR = 2,
}

/**
 * Describes the enum legebill.type.Tag.Source.
 */
export const Tag_SourceSchema: GenEnum<Tag_Source> = /*@__PURE__*/
  enumDesc(file_legebill_type_tag, 0, 0);

/**
 * @generated from enum legebill.type.Tag.SuggestionConfig
 */
export enum Tag_SuggestionConfig {
  /**
   * @generated from enum value: SUGGESTION_CONFIG_UNSPECIFIED = 0;
   */
  SUGGESTION_CONFIG_UNSPECIFIED = 0,

  /**
   * @generated from enum value: ELIGIBLE = 1;
   */
  ELIGIBLE = 1,

  /**
   * @generated from enum value: DISALLOWED = 2;
   */
  DISALLOWED = 2,
}

/**
 * Describes the enum legebill.type.Tag.SuggestionConfig.
 */
export const Tag_SuggestionConfigSchema: GenEnum<Tag_SuggestionConfig> = /*@__PURE__*/
  enumDesc(file_legebill_type_tag, 0, 1);

/**
 * @generated from enum legebill.type.Tag.Status
 */
export enum Tag_Status {
  /**
   * @generated from enum value: STATUS_UNSPECIFIED = 0;
   */
  STATUS_UNSPECIFIED = 0,

  /**
   * @generated from enum value: ENABLED = 1;
   */
  ENABLED = 1,

  /**
   * @generated from enum value: ARCHIVED = 2;
   */
  ARCHIVED = 2,
}

/**
 * Describes the enum legebill.type.Tag.Status.
 */
export const Tag_StatusSchema: GenEnum<Tag_Status> = /*@__PURE__*/
  enumDesc(file_legebill_type_tag, 0, 2);

/**
 * @generated from message legebill.type.DefaultTimesheetFieldValue
 */
export type DefaultTimesheetFieldValue = Message<"legebill.type.DefaultTimesheetFieldValue"> & {
  /**
   * @generated from field: string timesheet_field_id = 1;
   */
  timesheetFieldId: string;

  /**
   * @generated from field: string timesheet_field_option_id = 2;
   */
  timesheetFieldOptionId: string;
};

/**
 * Describes the message legebill.type.DefaultTimesheetFieldValue.
 * Use `create(DefaultTimesheetFieldValueSchema)` to create a new message.
 */
export const DefaultTimesheetFieldValueSchema: GenMessage<DefaultTimesheetFieldValue> = /*@__PURE__*/
  messageDesc(file_legebill_type_tag, 1);

/**
 * @generated from message legebill.type.TagShallow
 */
export type TagShallow = Message<"legebill.type.TagShallow"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * The Legebill site this tag belongs to.
   * Equivalent to a team ID.
   *
   * @generated from field: string site_id = 2;
   */
  siteId: string;

  /**
   * E.g. WT-1234
   *
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * Displayed to the user and used when searching for tags.
   *
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * @generated from field: string external_url = 5;
   */
  externalUrl: string;
};

/**
 * Describes the message legebill.type.TagShallow.
 * Use `create(TagShallowSchema)` to create a new message.
 */
export const TagShallowSchema: GenMessage<TagShallow> = /*@__PURE__*/
  messageDesc(file_legebill_type_tag, 2);

/**
 * @generated from message legebill.type.TagKeyword
 */
export type TagKeyword = Message<"legebill.type.TagKeyword"> & {
  /**
   * @generated from field: string tag_id = 1;
   */
  tagId: string;

  /**
   * @generated from field: string text = 2;
   */
  text: string;
};

/**
 * Describes the message legebill.type.TagKeyword.
 * Use `create(TagKeywordSchema)` to create a new message.
 */
export const TagKeywordSchema: GenMessage<TagKeyword> = /*@__PURE__*/
  messageDesc(file_legebill_type_tag, 3);

